import React, { useReducer, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Room, Lobby } from '../../components';
// import { PreReleaseLandingPage } from '../../components';
import toast from 'react-hot-toast';
import RoomSetup from '../Room/RoomSetup';
import PageContainerWithLogo from '../Core/PageContainerWithLogo';

import { AttemptUserLoginFlow, sessionUsername } from '../Core/LoginManager'

export default function RoomRouter( props )
{
  const [ , forceUpdate ] = useReducer( x => x + 1, 0 );
  const lobbyRef = useRef();
  const isJoiningRoomRef = useRef( false ); // Prevent duplicate room joining attempts
  const hasRegisteredCallbacksRef = useRef( false ); // Prevent duplicate callback registration
  let location = useLocation();
  let navigate = useNavigate();

  let gameStateManager = props.gameStateManager;

  const handleLogoClick = async () =>
  {
    if( lobbyRef.current )
    {
      await lobbyRef.current.refreshRoomsList();
    }
  };


  useEffect( () =>
  {
    // Prevent duplicate callback registration in React Strict Mode
    if( hasRegisteredCallbacksRef.current ) return;
    hasRegisteredCallbacksRef.current = true;

    // componentDidMount
    gameStateManager.onGameStartRegister( forceUpdate );

    return () =>
    {
      // componentWillUnmount
      gameStateManager.onGameStartUnregister( forceUpdate );
      hasRegisteredCallbacksRef.current = false;
    };
  }, [] );



  // return (
  //   <PreReleaseLandingPage />
  // );



  if( location.hash )
  {
    // Check if hash is a valid hash.

    if( isRoomHashValid( location.hash ) )
    {
      const urlRoomId = location.hash.substring( 1 );

      if( gameStateManager.socketConnectedRoomId )
      {
        // Client has been added to a room already
        // Check that the connected room ID matches the URL hash

        if( gameStateManager.socketConnectedRoomId === urlRoomId )
        {
          if( !gameStateManager.socketRoomHasStarted )
          {
            return (
              <PageContainerWithLogo>
                <RoomSetup />
              </PageContainerWithLogo>
            );
          }

          return (
            <Room />
          );
        }
        else
        {
          return ( <div>Attempting to join a Room { urlRoomId } but still associated with Room { gameStateManager.socketConnectedRoomId }</div> );
        }
      }
      else
      {
        // Client is attempting to join a room with this hash.
        // Check if the room hash matches an existing room ID.

        if( !sessionUsername )
        {
          // User hasn't logged in yet; must've opened up a fresh browser tab with this room URL
          // Need to log them in first

          AttemptUserLoginFlow(
            () =>
            {
              forceUpdate();
            },
            ( errorData ) =>
            {
              // Redirect the user back to the lobby (root domain URL) and show a toast message saying that they 'Cannot connect to the server'
              navigate( '/' );
              toast.error( 'Cannot connect to the server' );
            } );
        }
        else
        {
          // Prevent duplicate room joining attempts in React Strict Mode
          if( isJoiningRoomRef.current ) return ( <div>Attempting to join existing Room { location.hash }</div> );
          isJoiningRoomRef.current = true;

          gameStateManager.joinExistingRoomSocket( urlRoomId,
            ( roomId ) =>
            {
              // on room connect success
              console.log( "Room connect success." );

              // Add a small delay to ensure React components are stable
              // This prevents PIXI initialization issues when connecting via URL
              setTimeout( () =>
              {
                isJoiningRoomRef.current = false; // Reset flag on success
                forceUpdate();
              }, 100 ); // Small delay to let React settle
            },
            ( errorData ) =>
            {
              console.log( "Failed to join room. Redirecting to lobby.", errorData.content );

              // Redirect the user back to the lobby (root domain URL) and show a toast message with the errorData.content value
              navigate( '/' );
              toast.error( errorData.content );

              // on room connect fail
              isJoiningRoomRef.current = false; // Reset flag on error
            } );
        }

        return ( <div>Attempting to join existing Room { location.hash }</div> );
      }
    }
    else
    {
      // Invalid room hash. Redirect the user back to the lobby
      navigate( '/' );
      toast.error( 'Invalid room URL. Please check it is correct' );
    }
  }

  return (
    <PageContainerWithLogo onLogoClick={ handleLogoClick }>
      <Lobby ref={ lobbyRef } />
    </PageContainerWithLogo>
  );
}

function isRoomHashValid( roomHash )
{
  // check for starting hashtag symbol
  let hashIndex = roomHash.indexOf( '#' );

  if( hashIndex !== 0 )
  {
    return false;
  }

  // Check there aren't any other hashes
  hashIndex = roomHash.indexOf( '#', 1 );

  if( hashIndex >= 0 )
  {
    // console.log("format error: found hash at index " + hashIndex);
    return false;
  }

  if( roomHash.length !== 6 )
  {
    // console.log( "format error: wrong length." );
    return false;
  }

  return true;
}
